import { render, staticRenderFns } from "./DevicesMessages.vue?vue&type=template&id=3710a5be&scoped=true"
import script from "./DevicesMessages.vue?vue&type=script&lang=js"
export * from "./DevicesMessages.vue?vue&type=script&lang=js"
import style0 from "./DevicesMessages.vue?vue&type=style&index=0&id=3710a5be&prod&lang=scss&scoped=true"
import style1 from "./DevicesMessages.vue?vue&type=style&index=1&id=3710a5be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710a5be",
  null
  
)

export default component.exports